import React from 'react';
import { Card } from '../components/ui/card';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white pt-32 pb-20 px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Privacy Policy</h1>
        <p className="text-[#C7CCD8] mb-8">Last updated: December 13, 2025</p>

        <Card className="p-8 bg-white/5 border-[#1B2FFF]/20 mb-6">
          <div className="prose prose-invert max-w-none">
            <h2 className="text-2xl font-bold text-white mb-4">1. Information We Collect</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">
              At Liquicent, we collect information that you provide directly to us when you:
            </p>
            <ul className="list-disc list-inside text-[#C7CCD8] space-y-2 mb-6">
              <li>Request a demo or contact our sales team</li>
              <li>Create an account or deploy agents</li>
              <li>Use our platform and services</li>
              <li>Subscribe to our communications</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">2. How We Use Your Information</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">
              We use the information we collect to:
            </p>
            <ul className="list-disc list-inside text-[#C7CCD8] space-y-2 mb-6">
              <li>Provide, maintain, and improve our services</li>
              <li>Process your requests and transactions</li>
              <li>Send you technical notices and support messages</li>
              <li>Respond to your comments and questions</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">3. Data Security</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">
              We implement industry-standard security measures to protect your data:
            </p>
            <ul className="list-disc list-inside text-[#C7CCD8] space-y-2 mb-6">
              <li>End-to-end encryption for data in transit and at rest</li>
              <li>SOC 2 Type II certified infrastructure</li>
              <li>Regular security audits and penetration testing</li>
              <li>Role-based access controls</li>
              <li>Multi-factor authentication</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">4. Data Sharing and Disclosure</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">
              We do not sell your personal information. We may share your information only:
            </p>
            <ul className="list-disc list-inside text-[#C7CCD8] space-y-2 mb-6">
              <li>With your consent</li>
              <li>With service providers who assist in our operations</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights and prevent fraud</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">5. Your Rights</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">
              Depending on your location, you may have the following rights:
            </p>
            <ul className="list-disc list-inside text-[#C7CCD8] space-y-2 mb-6">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Export your data</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">6. Cookies and Tracking</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">
              We use cookies and similar tracking technologies to improve your experience and analyze usage patterns. You can control cookies through your browser settings.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">7. International Data Transfers</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">
              Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place for such transfers.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">8. Children's Privacy</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">
              Our services are not directed to individuals under 18. We do not knowingly collect information from children.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">9. Changes to This Policy</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">
              We may update this privacy policy from time to time. We will notify you of any material changes by posting the new policy on this page.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">10. Contact Us</h2>
            <p className="text-[#C7CCD8] leading-relaxed">
              If you have questions about this privacy policy, please contact us at:
              <br />
              <a href="mailto:privacy@liquicent.com" className="text-[#1B2FFF] hover:text-[#B8C6FF] transition-colors">
                privacy@liquicent.com
              </a>
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PrivacyPolicy;